import React from 'react';
import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { LandingPageHero } from '../../lp/LandingPageHero';
import { getCurrentVariantConfig, getActiveLpPromoBGColor } from '../../../utils/lpPromoConfig';
import heroImageMobile from '../../../images/lp/lp-men-hero-mobile.webp';
import heroImageDesktop from '../../../images/lp/lp-men-hero-desktop.webp';

function LandingPageHeroBuilder() {
    const variantConfig = getCurrentVariantConfig();
    const { copy, variant, subheading2First } = variantConfig;
    const bgColor = getActiveLpPromoBGColor();

    return (
        <div className="overflow-x-hidden">
            <LandingPageHero
                badge={copy.badge}
                eyebrow={copy.eyebrow}
                subheading1={copy.subheading1}
                heading={copy.heading}
                subheading2={copy.subheading2}
                subheading2First={subheading2First}
                highlightWord={copy.highlightWord}
                buttonText="RESERVE MY SPOT"
                buttonLink="#consult"
                heroImageMobile={heroImageMobile}
                heroImageDesktop={heroImageDesktop}
                imageAlt="Woman showing smooth underarm after laser hair removal treatment"
                variant={variant}
                bgColor={bgColor}
            />
        </div>
    );
}

Builder.registerComponent(LandingPageHeroBuilder, {
    name: BUILDER_DIVIDER_NAMES.LandingPageHero,
    friendlyName: 'Landing Page Hero',
});
